import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20" style={{ backgroundColor: 'var(--surface-cream)' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-blue)' }}>
              Contact Us
            </h2>
            <p className="text-xl" style={{ color: 'var(--text-secondary)' }}>
              We'd love to hear from you!
            </p>
            <div className="w-24 h-1 mx-auto mt-4 rounded-full" style={{ backgroundColor: 'var(--primary-green)' }}></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left: Contact Information */}
            <div className="space-y-6">
              <Card className="p-8 rounded-3xl border-0 shadow-lg" style={{ backgroundColor: 'white' }}>
                <h3 className="text-2xl font-bold heading-playful mb-6" style={{ color: 'var(--primary-red)' }}>
                  Get In Touch
                </h3>

                <div className="space-y-6">
                  {/* Address */}
                  <div className="flex items-start space-x-4">
                    <div className="p-3 rounded-xl" style={{ backgroundColor: 'var(--primary-blue)' }}>
                      <MapPin className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg mb-1" style={{ color: 'var(--text-primary)' }}>
                        Address
                      </h4>
                      <p style={{ color: 'var(--text-secondary)' }}>
                        Near Gita Bhawan Park<br />
                        Rampura Mohalla<br />
                        Hisar, Haryana, India
                      </p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start space-x-4">
                    <div className="p-3 rounded-xl" style={{ backgroundColor: 'var(--primary-green)' }}>
                      <Phone className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg mb-1" style={{ color: 'var(--text-primary)' }}>
                        Phone
                      </h4>
                      <a
                        href="tel:9467954126"
                        className="text-lg font-semibold hover:underline"
                        style={{ color: 'var(--primary-green)' }}
                      >
                        9467954126
                      </a>
                    </div>
                  </div>

                  {/* Timing */}
                  <div className="flex items-start space-x-4">
                    <div className="p-3 rounded-xl" style={{ backgroundColor: 'var(--primary-orange)' }}>
                      <Clock className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg mb-1" style={{ color: 'var(--text-primary)' }}>
                        Visiting Hours
                      </h4>
                      <p style={{ color: 'var(--text-secondary)' }}>
                        Monday - Saturday<br />
                        9:00 AM - 5:00 PM
                      </p>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-8 space-y-3">
                  <a href="tel:9467954126" className="block">
                    <Button
                      size="lg"
                      className="w-full rounded-xl text-lg font-semibold flex items-center justify-center space-x-2"
                      style={{ backgroundColor: 'var(--primary-green)', color: 'white' }}
                    >
                      <Phone className="h-5 w-5" />
                      <span>Call Now</span>
                    </Button>
                  </a>
                  <a href="https://wa.me/919467954126" target="_blank" rel="noopener noreferrer" className="block">
                    <Button
                      size="lg"
                      className="w-full rounded-xl text-lg font-semibold flex items-center justify-center space-x-2"
                      style={{ backgroundColor: 'var(--primary-green)', color: 'white' }}
                    >
                      <MessageCircle className="h-5 w-5" />
                      <span>WhatsApp Us</span>
                    </Button>
                  </a>
                </div>
              </Card>

              {/* Legacy Statement */}
              <Card className="p-6 rounded-3xl border-0 shadow-lg" style={{ backgroundColor: 'var(--primary-yellow)' }}>
                <p className="text-lg font-bold text-center" style={{ color: 'var(--text-primary)' }}>
                  Rooted in the legacy of HR Hindu High School, educating since 1943.
                </p>
              </Card>
            </div>

            {/* Right: Google Map */}
            <Card className="overflow-hidden rounded-3xl border-0 shadow-lg" style={{ backgroundColor: 'white' }}>
              <div className="h-full min-h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3483.8942763843676!2d75.72293631508103!3d29.149927382218566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39130e0d8f1e1111%3A0x1111111111111111!2sGita%20Bhawan%20Park%2C%20Rampura%2C%20Hisar%2C%20Haryana!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="HR KinderNova Location"
                  className="rounded-3xl"
                ></iframe>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;